import { render } from "./ModalCompact.vue?vue&type=template&id=69d2340a&scoped=true"
import script from "./ModalCompact.vue?vue&type=script&lang=js"
export * from "./ModalCompact.vue?vue&type=script&lang=js"

import "./ModalCompact.vue?vue&type=style&index=0&id=69d2340a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d2340a"]])

export default __exports__